import React from 'react';

const Programmes = () => {
  return (
    <div>
      Programmes
      Programmes
    </div>
  );
}

export default Programmes;
